import React, { useContext } from 'react';
import FilterInput from '../../../components/filter-input';

import { id } from '../../../../filters/options/order-number';
import { AdvancedSearchShipmentContext } from '../../context';
import messages from '../messages';

const OrderNumberFilter = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchShipmentContext);

  return <FilterInput filters={filters} id={id} labelMessage={messages.orderNumber} updateFilter={updateFilter} />;
};

export default OrderNumberFilter;
